import { render, staticRenderFns } from "./ProfileModal.vue?vue&type=template&id=59440c20&scoped=true"
import script from "./ProfileModal.vue?vue&type=script&lang=js"
export * from "./ProfileModal.vue?vue&type=script&lang=js"
import style0 from "./ProfileModal.vue?vue&type=style&index=0&id=59440c20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59440c20",
  null
  
)

export default component.exports